import { createAction } from 'redux-actions';

const actions = {
  /**
   *  추천 브랜드 데이터 변경하기
   */
  SET_DATA: 'recommend/store/SET_DATA',
  setData: createAction('recommend/store/SET_DATA'),

  /**
   *  추천 브랜드 리스트 가져오기
   */
  GET_RECOMMEND_STORE_LIST_REQUEST: 'recommend/store/GET_RECOMMEND_STORE_LIST_REQUEST',
  GET_RECOMMEND_STORE_LIST_SUCCESS: 'recommend/store/GET_RECOMMEND_STORE_LIST_SUCCESS',
  getRecommendStoreList: createAction('recommend/store/GET_RECOMMEND_STORE_LIST_REQUEST'),

  /**
   *  추천 브랜드 상세 요청하기
   */
  GET_RECOMMEND_STORE_DETAIL_REQUEST: 'recommend/store/GET_RECOMMEND_STORE_DETAIL_REQUEST',
  GET_RECOMMEND_STORE_DETAIL_SUCCESS: 'recommend/store/GET_RECOMMEND_STORE_DETAIL_SUCCESS',
  getRecommendStoreDetail: createAction('recommend/store/GET_RECOMMEND_STORE_DETAIL_REQUEST'),

  /**
   *  추천 브랜드 복사하기 전 필요한 데이터 가져오기
   */
  PREPARE_COPY_RECOMMEND_STORE_REQUEST: 'recommend/store/PREPARE_COPY_RECOMMEND_STORE_REQUEST',
  PREPARE_COPY_RECOMMEND_STORE_SUCCESS: 'recommend/store/PREPARE_COPY_RECOMMEND_STORE_SUCCESS',
  prepareCopyRecommendStore: createAction('recommend/store/PREPARE_COPY_RECOMMEND_STORE_REQUEST'),

  /**
   *  추천 브랜드 등록하기 전 필요한 데이터 가져오기
   */
  PREPARE_CREATE_RECOMMEND_STORE_REQUEST: 'recommend/store/PREPARE_CREATE_RECOMMEND_STORE_REQUEST',
  PREPARE_CREATE_RECOMMEND_STORE_SUCCESS: 'recommend/store/PREPARE_CREATE_RECOMMEND_STORE_SUCCESS',
  prepareCreateRecommendStore: createAction('recommend/store/PREPARE_CREATE_RECOMMEND_STORE_REQUEST'),

  /**
   *  추천 브랜드에 연결할 아이템 리스트 요청하기
   */
  GET_RECOMMEND_STORE_ITEM_REQUEST: 'recommend/store/GET_RECOMMEND_STORE_ITEM_REQUEST',
  GET_RECOMMEND_STORE_ITEM_SUCCESS: 'recommend/store/GET_RECOMMEND_STORE_ITEM_SUCCESS',
  getRecommendStoreItemList: createAction('recommend/store/GET_RECOMMEND_STORE_ITEM_REQUEST'),

  /**
   *  추천 브랜드 등록/복사하기
   */
  CREATE_RECOMMEND_STORE_REQUEST: 'recommend/store/CREATE_RECOMMEND_STORE_REQUEST',
  createRecommendStore: createAction('recommend/store/CREATE_RECOMMEND_STORE_REQUEST'),

  /**
   *  전체 브랜드 리스트 EXCEL 다운로드
   */
  GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/store/GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getRecommendStoreItemListExcelDownload: createAction(
    'recommend/store/GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  선택된 브랜드 리스트 EXCEL 다운로드
   */
  GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST:
    'recommend/store/GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  getSelectedRecommendStoreItemListExcelDownload: createAction(
    'recommend/store/GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST',
  ),

  /**
   *  브랜드 리스트 EXCEL 업로드
   */
  SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST:
    'recommend/store/SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_SUCCESS: 'recommend/store/SET_RECOMMEND_STORE_ITEM_EXCEL_UPLOAD_SUCCESS',
  setRecommendStoreItemListExcelUpload: createAction(
    'recommend/store/SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST',
  ),
};

export default actions;
